var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SoliForm", {
    ref: "form",
    attrs: {
      title: _vm.editing
        ? `Edit ${_vm.product.name}`
        : `Create ${_vm.form.category?.singular ?? "Product"}`,
      saveChanges: _vm.editing ? _vm.edited : true,
      imgSrc: _vm.getImageSource,
      persistent: "",
    },
    on: {
      success: function ($event) {
        return _vm.$emit("success")
      },
      reset: function ($event) {
        return _vm.$emit("reset")
      },
      submit: _vm.submit,
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "div",
              {
                staticClass: "flex flex-col gap-4",
                class: { "mt-4 py-2": !!_vm.getImageSource },
              },
              [
                false
                  ? _c("v-select", {
                      attrs: {
                        label: "Category",
                        "prepend-inner-icon": "category",
                        "item-text": "title",
                        "item-value": "title",
                        "return-object": "",
                        items: [
                          {
                            title: "Books",
                            singular: "A Book",
                          },
                          {
                            title: "Merch",
                            singular: "Merchandise",
                          },
                        ],
                        rules: _vm.rules.select,
                        hideDetails: "auto",
                      },
                      model: {
                        value: _vm.form.category,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "category", $$v)
                        },
                        expression: "form.category",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("SoliText", {
                  attrs: {
                    disabled: !!_vm.product?.id && !_vm.product?.physical,
                    rules: _vm.rules.input,
                    "error-messages": _vm.errors.name,
                    label: "Name",
                    icon: "book",
                    hideDetails: "auto",
                  },
                  model: {
                    value: _vm.form.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "name", $$v)
                    },
                    expression: "form.name",
                  },
                }),
                _vm._v(" "),
                _c("SoliText", {
                  attrs: {
                    disabled: !!_vm.product?.id && !_vm.product?.physical,
                    rules: _vm.rules.input,
                    "error-messages": _vm.errors.description,
                    label: "Description",
                    icon: "description",
                    hideDetails: "auto",
                  },
                  model: {
                    value: _vm.form.description,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "description", $$v)
                    },
                    expression: "form.description",
                  },
                }),
                _vm._v(" "),
                _c("v-currency-field", {
                  staticClass: "soli-round",
                  attrs: {
                    rules: _vm.priceRules,
                    "error-messages": _vm.errors.price,
                    outlined: "",
                    dense: "",
                    label: "Price",
                    "error-message": "errors.amount",
                    "prepend-inner-icon": "attach_money",
                    "hide-details": "auto",
                  },
                  model: {
                    value: _vm.form.price,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "price", $$v)
                    },
                    expression: "form.price",
                  },
                }),
                _vm._v(" "),
                (!_vm.product?.id || _vm.product?.physical) &&
                (_vm.showFileInput || !_vm.product?.photo)
                  ? _c("v-file-input", {
                      ref: "fileInput",
                      attrs: {
                        "error-messages": _vm.errors.image,
                        rules: _vm.imageRules,
                        outlined: "",
                        dense: "",
                        "hide-details": "auto",
                        "prepend-inner-icon": "image",
                        label: "Image",
                        "prepend-icon": "",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.convertPhoto($event)
                        },
                        "click:clear": function ($event) {
                          _vm.showImageEditor = false
                        },
                      },
                      model: {
                        value: _vm.form.image,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "image", $$v)
                        },
                        expression: "form.image",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.showFileInput && _vm.product?.photo
                  ? _c("v-text-field", {
                      attrs: {
                        value: _vm.product?.photo?.split("/product-images/")[1],
                        "error-messages": _vm.errors.image,
                        outlined: "",
                        clearable: "",
                        dense: "",
                        "hide-details": "auto",
                        "prepend-inner-icon": "image",
                        label: "Image",
                        "prepend-icon": "",
                      },
                      on: {
                        focus: function ($event) {
                          return _vm.selectNewPhoto()
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.product?.photo && !_vm.showFileInput && false
                  ? _c("v-img", {
                      staticClass: "cursor-pointer soli-round",
                      attrs: {
                        width: "200",
                        height: "200",
                        src: _vm.product.imagePath
                          ? `/api/image-service/400x400/${_vm.product.imagePath}`
                          : _vm.product.photo,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.selectNewPhoto()
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showImageEditor
                  ? _c(
                      "div",
                      { staticClass: "soli-round" },
                      [
                        _vm.cropperLoading
                          ? _c(
                              "v-container",
                              [
                                _c("v-skeleton-loader", {
                                  staticClass: "soli-round",
                                  attrs: { type: "image" },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("VueCropper", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.cropperLoading,
                              expression: "!cropperLoading",
                            },
                          ],
                          ref: "cropper",
                          attrs: {
                            src: null,
                            viewMode: 1,
                            aspectRatio: 1,
                            zoomable: false,
                            autoCropArea: 1,
                            containerStyle: { height: "200px" },
                            alt: "Loading",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v
      },
      expression: "valid",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }